import ContentFragment from './ContentFragment';
export default `
	query ListContent($filter: JSON, $limit: Int, $offset: Int, $provider: String) {
		listContent(filter: $filter, limit: $limit, offset: $offset, provider: $provider) {
			total
			size
			items {
				...ContentFragment
			}
		}
	}
	${ContentFragment}
`;
